import React, { PureComponent, Fragment } from "react";
import styled, { css, keyframes } from 'styled-components';
import Odometer from "react-odometerjs";

import "odometer/themes/odometer-theme-default.css";
import "./TotalCount.css";
import ConsoleLog from './../../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc Reports TotalCount Diplaying component
 * @param props
 * @return null
 * @author Praveen George, Lakshmikanth,Jamshith
 */
class TotalCount extends PureComponent {
  //ConsoleLog(this.props.count);
  render() {
    const keyFrames = keyframes`
      0% { width: 0px; }
      100% { width: 60px; }
    }`;

    const animation = () => css`
      ${keyFrames} 1s ease-out forwards;
    `;

    let Style = styled.span`
    animation: ${animation};`;

    return (
      <Fragment>
        <div className={"card-item first-row " + this.props.className}>
          <h6>{this.props.title}</h6>
          <h2 id={this.props.id}>
            <Odometer 
              format="d" 
              duration={1000} 
              value={this.props.count} 
            />
          </h2>
          <Style className="count-bar" style={{ background: this.props.bgcolor }}/>
        </div>
      </Fragment>
    );
  }
};

export default TotalCount;



// WEBPACK FOOTER //
// ./src/components/UI/ReportsComponents/TotalCount/TotalCount.js